import { render } from "./MessageSection.vue?vue&type=template&id=00d65e9a&scoped=true"
import script from "./MessageSection.vue?vue&type=script&lang=js"
export * from "./MessageSection.vue?vue&type=script&lang=js"

import "./MessageSection.vue?vue&type=style&index=0&id=00d65e9a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d65e9a"]])

export default __exports__